import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import Button from "@mui/material/Button";
import {fetchSkipStats} from "./portalRedirectCampaignsService";
import Loading from "../../components/loading";

type Props = {
    hpCampaignId: number | null;
    startDate: string;
    endDate: string;
    onClose: () => void;
};

export default function PrSkipStatsModal({hpCampaignId, startDate, endDate, onClose}: Props) {
    const [loading, setLoading] = React.useState(false);
    const [rows, setRows] = React.useState<any[]>([]);

    React.useEffect(() => {
        if (!hpCampaignId) {
            setRows([]);
            return;
        }
        setLoading(true);
        fetchSkipStats(hpCampaignId, startDate, endDate).then((data) => {
            setRows(data);
            setLoading(false);
        });
    }, [hpCampaignId, startDate, endDate]);

    const pct = (n: number, d: number) => d ? ((n / d) * 100).toFixed(1) : "0.0";

    return (
        <Dialog open={!!hpCampaignId} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Skip Stats</DialogTitle>
            <DialogContent>
                {loading ? <Loading/> : (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Seeking</TableCell>
                                <TableCell align="right">Impressions</TableCell>
                                <TableCell align="right">Submissions</TableCell>
                                <TableCell align="right">Skips</TableCell>
                                <TableCell align="right">Bails</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((r) => {
                                const bails = (r.impressions || 0) - (r.submissions || 0) - (r.skips || 0);
                                return (
                                    <TableRow key={r.degree}>
                                        <TableCell>{r.degree}</TableCell>
                                        <TableCell align="right">{r.impressions}</TableCell>
                                        <TableCell align="right">{r.submissions} ({pct(r.submissions, r.impressions)}%)</TableCell>
                                        <TableCell align="right">{r.skips} ({pct(r.skips, r.impressions)}%)</TableCell>
                                        <TableCell align="right">{bails} ({pct(bails, r.impressions)}%)</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
